
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleConsultationClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/consulting');
  };

  const handleLoginClick = () => {
    window.open('http://michael-jackson-s-school7.teachable.com/sign_in', '_blank');
  };

  const handleNavClick = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-gray-800">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center space-x-3"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center">
              <i className="ri-car-line text-2xl text-black"></i>
            </div>
            <div>
              <div className="font-bold text-white text-lg" style={{ fontFamily: '"Pacifico", serif' }}>
                Georgia Dealer License
              </div>
              <div className="text-xs text-gray-300">Complete Training Program</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => handleNavClick('/course')}
              className="text-white hover:text-yellow-400 font-medium transition-colors cursor-pointer"
            >
              Course
            </button>
            <button 
              onClick={() => handleNavClick('/resources')}
              className="text-white hover:text-yellow-400 font-medium transition-colors cursor-pointer"
            >
              Resources
            </button>
            <button 
              onClick={() => handleNavClick('/consulting')}
              className="text-white hover:text-yellow-400 font-medium transition-colors cursor-pointer"
            >
              Consulting
            </button>
            <button 
              onClick={() => handleNavClick('/support')}
              className="text-white hover:text-yellow-400 font-medium transition-colors cursor-pointer"
            >
              Support
            </button>
            <button 
              onClick={() => handleNavClick('/faq')}
              className="text-white hover:text-yellow-400 font-medium transition-colors cursor-pointer"
            >
              FAQ
            </button>
          </nav>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button 
              onClick={handleLoginClick}
              className="text-white hover:text-yellow-400 font-medium transition-colors"
            >
              Login
            </button>
            <button
              onClick={handleConsultationClick}
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-6 py-3 rounded-full font-bold hover:from-yellow-500 hover:to-yellow-600 transition-all whitespace-nowrap"
            >
              Book Consultation
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white hover:text-yellow-400 transition-colors"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-sm border-t border-gray-700">
            <nav className="flex flex-col py-6 px-6 space-y-4">
              <button 
                onClick={() => handleNavClick('/course')}
                className="text-left text-white hover:text-yellow-400 font-medium transition-colors py-2"
              >
                Course
              </button>
              <button 
                onClick={() => handleNavClick('/resources')}
                className="text-left text-white hover:text-yellow-400 font-medium transition-colors py-2"
              >
                Resources
              </button>
              <button 
                onClick={() => handleNavClick('/consulting')}
                className="text-left text-white hover:text-yellow-400 font-medium transition-colors py-2"
              >
                Consulting
              </button>
              <button 
                onClick={() => handleNavClick('/support')}
                className="text-left text-white hover:text-yellow-400 font-medium transition-colors py-2"
              >
                Support
              </button>
              <button 
                onClick={() => handleNavClick('/faq')}
                className="text-left text-white hover:text-yellow-400 font-medium transition-colors py-2"
              >
                FAQ
              </button>
              <div className="flex flex-col space-y-3 pt-4 border-t border-gray-700">
                <button 
                  onClick={() => {
                    handleLoginClick();
                    setIsMenuOpen(false);
                  }}
                  className="text-left text-white hover:text-yellow-400 font-medium transition-colors py-2"
                >
                  Login
                </button>
                <button
                  onClick={() => {
                    handleConsultationClick();
                    setIsMenuOpen(false);
                  }}
                  className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-6 py-3 rounded-full font-bold hover:from-yellow-500 hover:to-yellow-600 transition-all text-center whitespace-nowrap"
                >
                  Book Consultation
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
